exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".backgroundImage{width:100%;z-index:0;position:absolute;bottom:0;right:0;left:0}@media screen and (max-width:900px){.backgroundImage{bottom:30%}}@media screen and (max-width:400px){.backgroundImage{bottom:40%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/BackgroundImage/styles.sass
// module id = 112
// module chunks = 0